module.exports = __webpack_public_path__ + "static/media/ba.f27ae1ea.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ba.svg
// module id = 863
// module chunks = 0